import React from 'react';

import {MenuItem, Select} from '@mui/material';

const selectSx = {
    fontSize: 13,
    fontFamily: 'inherit',
    borderRadius: 2,
    minWidth: 200,
    '& fieldset': {borderColor: 'var(--panels-normal-color)'},
    '& .MuiSelect-select': {fontSize: 13, fontFamily: 'inherit', py: 0.75},
};

const paperClass = 'p-2 mt-1 rounded-input shadow-lg';
const paperSx = {fontFamily: 'inherit', '& *': {fontFamily: 'inherit'}};
const menuItemClass = '!flex !flex-col !items-stretch !px-3 !py-2 !mb-1 last:!mb-0 !rounded-input aria-selected:!bg-panels-normal hover:aria-selected:!bg-panels-hover';
const menuItemSx = {fontFamily: 'inherit'};

const MENU_PROPS = {PaperProps: {className: paperClass, sx: paperSx}};

const Option = ({title, body}) => (
    <div className="flex flex-col">
        <span className="text-[13px] font-semibold text-main-normal leading-tight">{title}</span>
        {body && <span className="text-[11px] text-main-hover mt-0.5 leading-tight">{body}</span>}
    </div>
);

const StyledOptionSelect = ({value, onChange, options, sx, 'data-testid': testId}) => {
    const selected = options.find((o) => o.value === value);
    return (
        <Select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            size="small"
            sx={{...selectSx, ...sx}}
            renderValue={() => selected?.title || ''}
            MenuProps={MENU_PROPS}
            data-testid={testId || 'styled-option-select'}
        >
            {options.map((o) => (
                <MenuItem key={o.value} value={o.value} className={menuItemClass} sx={menuItemSx} data-testid={`select-option-${o.value}`}>
                    <Option title={o.title} body={o.body} />
                </MenuItem>
            ))}
        </Select>
    );
};

export default StyledOptionSelect;
